import React from 'react';
import {FlatList, View} from 'react-native';

import Text from '/component/base/Text';
import {keyExtractor} from '/component/screen/ReleaseNotes/ReleaseNotes.util';

import {styles} from './Note.style';
import {getDate} from './Note.util';
import {Section} from './Section';

// Define the types for the section content
interface SectionContent {
  title: string;
  description: string;
  points: string[];
}

// Define the structure of the sections
interface SectionType {
  title: string;
  imageUrl?: string;
  content: SectionContent[];
}

interface NoteItem {
  date: string;
  version: string;
  sections: SectionType[];
}

interface NoteProps {
  item: NoteItem;
}

export const Note: React.FC<NoteProps> = ({
  item = {
    date: '',
    version: '',
    sections: [],
  },
}: NoteProps) => {
  const {date, version, sections} = item;

  const renderItem = ({item}: {item: SectionType}) => <Section item={item} />;

  return (
    <View style={styles.container}>
      <Text variant="heading" style={styles.date}>
        {getDate({date})}
      </Text>
      <Text variant="caption" style={styles.version}>
        {version}
      </Text>
      <FlatList
        data={sections}
        keyExtractor={keyExtractor}
        renderItem={renderItem}
      />
    </View>
  );
};
